import axios from 'axios'

const state = {
    platforms: [],
    advertisers: [],
    campaigns: [],
    gotEntities: false,
    platforms_mappings: {},
    advertisers_mappings: {},
    campaigns_mappings: {},
}

const getters = {
    getPlatforms: state => state.platforms,
    getAdvertisers: state => state.advertisers,
    getCampaigns: state => state.campaigns,
    gotEntities: state => state.gotEntities,
    mappedPlatforms: state => state.platforms_mappings,
    mappedAdvertisers: state => state.advertisers_mappings,
    mappedCampaigns: state => state.campaigns_mappings,
}

const actions = {
    fetchEntities: ({commit}) => {
        axios.all([axios.get('platforms/'), axios.get('participants/'), axios.get('campaigns/')])
          .then(axios.spread((pl, adv, cmp) => {
              let platforms = pl.data              
              if (platforms.length) {
                platforms = platforms.sort((a,b) => a.name.localeCompare(b.name))                
                commit('MAP_PLATFORMS', platforms)
              }
              commit('FETCH_PLATFORMS', platforms)

              let advertisers = adv.data
              if (advertisers.length) {
                advertisers = advertisers.sort((a,b) => a.name.localeCompare(b.name))                
                commit('MAP_ADVERTISERS', advertisers)
              }
              commit('FETCH_ADVERTISERS', advertisers)

              let campaigns = cmp.data
              if (campaigns.length) {
                campaigns = campaigns.sort((a,b) => a.name.localeCompare(b.name))                
                commit('MAP_CAMPAIGNS', campaigns)     
              }
              commit('FETCH_CAMPAIGNS', campaigns)
          }))
          .then(() => {
              commit('GOT_ENTITIES')
          })
    },
}

const mutations = {
    FETCH_PLATFORMS: (state, platforms) => {
        state.platforms = platforms 
    },
    FETCH_ADVERTISERS: (state, advertisers) => {
        state.advertisers = advertisers 
    },
    FETCH_CAMPAIGNS: (state, campaigns) => {
        state.campaigns = campaigns 
    },
    MAP_PLATFORMS: (state, platforms) => {
        let mappings = {}
        platforms.map(platform => {
          mappings[platform.external_id] = platform.name
        })
        state.platforms_mappings = mappings
    },
    MAP_ADVERTISERS: (state, advertisers) => {
        let mappings = {}
        advertisers.map(advertiser => {
          mappings[advertiser.external_id] = advertiser.name
        })
        state.advertisers_mappings = mappings
    },
    MAP_CAMPAIGNS: (state, campaigns) => {
        let mappings = {}
        campaigns.map(campaign => {
          mappings[campaign.external_id] = campaign.name
        })
        state.campaigns_mappings = mappings
    },
    GOT_ENTITIES: (state) => {
        state.gotEntities = true
    },
    STALE_ENTITIES: (state) => {
        state.gotEntities = false
    }
}

export default {
    state,
    getters,
    actions,
    mutations,
  };